export enum INTRODUCING_BROKER_MEMBER_PILL {
  PLATFORM = "platform",
  LOCAL_MARKET = "local_market",
  GLOBAL_MARKET = "global_market",
}
